import classNames from 'classnames'
import { ReactNode, useEffect, useState } from 'react'
import Icon from '../icon'

export const Accordion = ({
  children,
  title,
  open,
  className = '',
}: {
  children: ReactNode
  title: string
  open?: boolean
  className?: string
}) => {
  const [isOpen, setIsOpen] = useState(false)

  useEffect(() => {
    if (open !== undefined) {
      setIsOpen(open)
    }
  }, [open])

  return (
    <div className={classNames('flex flex-col gap-6 w-full', className)}>
      <button
        className="flex items-center justify-between gap-4"
        onClick={() => {
          setIsOpen(!isOpen)
        }}
        type="button"
      >
        <p className="font-semibold text-xl tracking-[-0.01em] text-black">
          {title}
        </p>

        <Icon
          id={'left-caret'}
          width={18}
          height={16}
          className={classNames('transition-all duration-300', {
            '-rotate-90': !isOpen,
            'rotate-90': isOpen,
          })}
        />
      </button>

      {isOpen && <div className="animate-fadeIn w-full">{children}</div>}
    </div>
  )
}
